/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const n=2**32,t=2**16;function r(r){return Math.floor(r/n)%t}function o(t){return t%n}function u(t,r){return t*n+r}export{r as getParquetFileId,u as getParquetObjectId,o as getParquetRowId};
